import { useEffect, useState } from 'react'

import { produce } from 'immer'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { AllIcons } from 'helpers/allIcons'
import { putProfileSettings } from 'services/endpoints/settings/account/profileSettings'
import { useUserProfile } from 'store'
import { type IProfile } from 'types/interfaces/IProfile'

import { SSAccordion } from '../SSAccordion'

interface IPostSettings {
    auto_post_to_twitter: boolean
    post_preview_type: string | null
}

export const Post = () => {
    const [postSettingsState, setPostSettingsState] = useState<IPostSettings>({
        auto_post_to_twitter: false,
        post_preview_type: null
    })

    const userData = useUserProfile()
    const queryClient = useQueryClient()
    const { t } = useTranslation()

    useEffect(() => {
        if (userData) {
            setPostSettingsState({
                auto_post_to_twitter: userData.auto_post_to_twitter,
                post_preview_type: userData.post_preview_type
            })
        }
    }, [userData])

    const cachedData = queryClient.getQueryData<IProfile>('user-profile')

    const toggleFunction = useMutation(
        async (newPostSettings: {
            key: string
            value: boolean | string | null
        }) => {
            const { key, value } = newPostSettings
            setPostSettingsState({ ...postSettingsState, [key]: value })
            return await putProfileSettings({ [key]: value })
        },
        {
            onMutate: (vars: { key: string; value: boolean | string }) => {
                const { key, value } = vars
                if (cachedData) {
                    const newData: IProfile = produce(cachedData, draft => {
                        return { ...draft, [key]: value }
                    })
                    queryClient.setQueryData('user-profile', newData)
                }
            },
            onError: err => {
                console.error(err)
                queryClient.setQueryData('user-profile', cachedData)
                addToast('error', t('error:errorSomethingWentWrong'))
            }
        }
    )

    return (
        <>
{/*             {userData?.twitter_nickname && (
                <ActionCard
                    icon={AllIcons.twitter_active}
                    iconSize='small'
                    text={t('twitter')}
                    subtext={`@${userData.twitter_nickname}`}
                />
            )}
            <ActionCard
                text={t('autoPostToTwitter')}
                hasSwitch
                toggleFn={() => {
                    if (userData?.twitter) {
                        toggleFunction.mutate({
                            key: 'auto_post_to_twitter',
                            value: !postSettingsState.auto_post_to_twitter
                        })
                    } else {
                        addToast(
                            'error',
                            t('error:addYourTwitterAccountInAccountSettings')
                        )
                    }
                }}
                toggleActive={postSettingsState.auto_post_to_twitter}
            /> */}

            <SSAccordion
                expanded={true}
                head={<>{t('premiumVideos')}</>}
                items={[
                    {
                        text: t('noPreview'),
                        active:
                            postSettingsState.post_preview_type ===
                            'no-preview',
                        toggle: () => {
                            setPostSettingsState({
                                ...postSettingsState,
                                post_preview_type: 'no-preview'
                            })
                            toggleFunction.mutate({
                                key: 'post_preview_type',
                                value: 'no-preview'
                            })
                        }
                    },
                    {
                        text: t('picturePreview'),
                        active:
                            postSettingsState.post_preview_type === 'picture',
                        toggle: () => {
                            setPostSettingsState({
                                ...postSettingsState,
                                post_preview_type: 'picture'
                            })
                            toggleFunction.mutate({
                                key: 'post_preview_type',
                                value: 'picture'
                            })
                        }
                    },
                    {
                        text: t('videoPreview'),
                        active: postSettingsState.post_preview_type === 'video',
                        toggle: () => {
                            setPostSettingsState({
                                ...postSettingsState,
                                post_preview_type: 'video'
                            })
                            toggleFunction.mutate({
                                key: 'post_preview_type',
                                value: 'video'
                            })
                        }
                    }
                ]}
            />
        </>
    )
}
